import { render, staticRenderFns } from "./12345_mailbox.vue?vue&type=template&id=7ca7be7c&"
import script from "./12345_mailbox.vue?vue&type=script&lang=js&"
export * from "./12345_mailbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports